import { DEFAULT_PAGE } from '@anm/data/video-templates/defaults';
import pageData, { PageName } from '@anm/data/video-templates/pages';
import { useSelector } from 'react-redux';

import { TemplateListQuery } from '../helpers/videoTemplates/dispatchCurrentTemplateNew';
import { templateSelectors } from '../store/modules/template';

let prevPageName = '' as PageName;

export default ({ pageName: pageNameOrTemplateid }: TemplateListQuery) => {
  const pageNameFromStore = useSelector(templateSelectors.selectTemplatePage);

  const pageNameOrTemplateId =
    pageNameFromStore || prevPageName || pageNameOrTemplateid;

  if (pageNameFromStore !== DEFAULT_PAGE) {
    prevPageName = pageNameFromStore;
  }
  return pageData[pageNameOrTemplateId] ? pageNameOrTemplateId : DEFAULT_PAGE;
};
